import { CHANGE_BREAKPOINT } from '../constants'

const initialState = 'desktop'

export default function update(state = initialState, action) {
  if (action.type === CHANGE_BREAKPOINT) {
    return action.device
  }
  return state
}



// WEBPACK FOOTER //
// ./src/reducers/breakpointReducer.js